import React, { useEffect, useState } from 'react';
import { Btn, Loading, Msg, Section, useAdminGet } from '../kit';
import { ChangePlanModal, type PlanInfo, describePlanChange, planLines } from '../billing/ChangePlanModal';

/** The account's plan, inside UserDrawer: what they are on now (trial or
 *  paid, end date, renewal, Razorpay mandate) and the Change plan dialog —
 *  the same one Billing → Users opens. */
export const PlanSection: React.FC<{ userId: string; onChanged?: () => void }> = ({ userId, onChanged }) => {
  const plan = useAdminGet<PlanInfo>('users', 'plan', { user_id: userId }, [userId]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState<{ kind: 'error' | 'ok'; text: string } | null>(null);
  // A deep link can swap the account under an open drawer; never carry the
  // dialog (or the last account's result) over to a different one.
  useEffect(() => { setOpen(false); setMsg(null); }, [userId]);

  const d = plan.data;
  const lines = planLines(d);

  const changed = (res: any) => {
    setOpen(false);
    setMsg(describePlanChange(res));
    plan.reload();
    onChanged?.();
  };

  return (
    <Section title="Plan" right={
      <div className="flex items-center gap-2">
        <Btn small onClick={plan.reload}>Refresh</Btn>
        <Btn small kind="primary" disabled={!d} onClick={() => { setMsg(null); setOpen(true); }}
          title="Move this account to another plan (Explorer, Voyager, …), with an optional e-mail">
          Change plan…
        </Btn>
      </div>
    }>
      {plan.error && <Msg kind="error">{plan.error}</Msg>}
      {plan.loading && !d ? <Loading /> : d && (
        <div className="flex flex-col gap-0.5">
          <div className="text-sm text-grayscale-1300"><b>{lines.head}</b></div>
          {lines.detail && <div className="text-xs text-grayscale-1100">{lines.detail}</div>}
          {lines.lifecycle && <div className="text-xs text-grayscale-1100">Lifecycle: {lines.lifecycle}</div>}
        </div>
      )}
      {msg && <Msg kind={msg.kind}>{msg.text}</Msg>}
      {open && <ChangePlanModal userId={userId} onClose={() => setOpen(false)} onDone={changed} />}
    </Section>
  );
};

export default PlanSection;
